// components/Video.js

import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Play } from 'lucide-react';
import { videoData } from '../data/videosData';

// ✅ Individual video block (exported separately for project pages)
export const VideoSection = ({ videoUrl, serviceType, location, description, serviceLink, coverImage, isVideoLeft }) => {
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  const handleVideoClick = () => setIsVideoVisible(true);

  return (
    <div className={`flex bg-background flex-col md:flex-row h-auto lg:h-[380px] ${isVideoLeft ? '' : 'md:flex-row-reverse'} items-center`}>
      {/* Video + overlay */}
      <div className="md:w-1/2 w-full h-full relative">
        {!isVideoVisible ? (
          <div className="relative w-full max-w-[650px] h-[192px] lg:h-full group overflow-hidden cursor-pointer" onClick={handleVideoClick}>
            <Image
              src={coverImage}
              alt={`${serviceType} - ${location}`}
              title={`${serviceType} - ${location}`}
              width={1080}
              height={675}
              className="w-full h-full object-cover shadow-lg transform group-hover:scale-110 transition duration-500"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 650px"
              quality={70}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-black bg-opacity-30 p-4 rounded-full group-hover:bg-opacity-70 transition duration-500">
                <Play className="text-white w-10 h-10 pl-1" />
              </div>
            </div>
          </div>
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={`${videoUrl}?autoplay=1`}
            title={`${serviceType} - ${location}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full rounded-none shadow-lg aspect-video"
          />
        )}
      </div>

      {/* Description */}
      <div className="md:w-1/2 w-full px-6">
        <h2 className="text-xs lg:text-lg text-gray font-light tracking-[3px] mt-4 lg:mt-0 uppercase mb-2">
          {serviceType}
        </h2>
        <h3 className="text-xl lg:text-3xl font-light font-gilda mb-2">{location}</h3>
        <p className="text-sm lg:text-lg text-gray font-light mb-6">{description}</p>
        <Link
          href={serviceLink}
          className="btn text-center px-6 py-3 mb-10 w-full lg:w-auto"
        >
          <span className="font-light text-md uppercase tracking-[3px]">
            View {serviceType}
          </span>
        </Link>
      </div>
    </div>
  );
};

// ✅ Component that loops all videos from data file
const VideoComponent = () => {
  return (
    <section className="bg-white py-[120px]">
      <div className="container mx-auto px-6">
        {videoData.map((video, index) => (
          <VideoSection
            key={index}
            videoUrl={video.videoUrl}
            serviceType={video.serviceType}
            location={video.location}
            description={video.description}
            serviceLink={video.serviceLink}
            coverImage={video.coverImage}
            isVideoLeft={index % 2 === 0}
          />
        ))}
      </div>
    </section>
  );
};

export default VideoComponent;
